import type { interfaces } from '@patsnap/tahiti-core/shared/inversify';
import { CreditModelImpl } from './models/impls/credit-model';
import { CreditModel } from './models/credit-model';
import { CreditService } from './services/credit-service';
import { CreditServiceImpl } from './services/impls/credit-service';
import { UsageService } from './services/usage-service';
import { UsageCalculator } from './services/usage-calculator';
import { UsageCalculatorImpl } from './services/impls/usage-calculator';
import { UsageServiceImpl } from './services/impls/usage-service';

export const creditModule = (bind: interfaces.Bind) => {
    bind(CreditModel).to(CreditModelImpl);
    bind(CreditService).to(CreditServiceImpl);
    bind(UsageCalculator).to(UsageCalculatorImpl);
    bind(UsageService).to(UsageServiceImpl);
};
